import * as Actions from './actions'
import {initialState} from '../store/initialState'

export const MakersReducer = (state = initialState.makers, action) =>{
    switch(action.type){
        case Actions.DELETE_MAKERS:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.FETCH_MAKERS:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.INIT_MAKERS:
            return {
                ...initialState.products
            };
        default:
            return state
    }
}